import { useCallback, useEffect, useState } from 'react';

import superagent from '@ott/superagent';

import { IframeDataAdaptedType, ThreeDSAuthResult, ThreeDSTwoAuthAdapted } from '../../../types';
import prepareQuery from '../helpers/prepareQuery';
import { isThreeDSTwoAuth } from '../helpers/threeDSSteps';

export default function useThreeDSAuth({
  iframeData,
  onResult,
  onError,
}: {
  iframeData: IframeDataAdaptedType;
  onResult: (result: ThreeDSAuthResult) => void;
  onError: VoidFunction;
}) {
  const [isPolling, setIsPolling] = useState(true);

  const pollingHandler = useCallback(
    async (value: ThreeDSTwoAuthAdapted) => {
      const { threeDSMethodData, TermUrl } = value;
      const processId = TermUrl.split('/')[5];
      const query = prepareQuery();
      try {
        const {
          body: { result },
        } = await superagent
          .post('/_virtual_cards/abb/three-ds-v2-check')
          .query(query)
          .send({ threeDSMethodData, processId });

        if (!result.continue) {
          setIsPolling(false);
          onResult({ errorCode: result.error, result });
        }
      } catch (error) {
        setIsPolling(false);
        onError();
      }
    },
    [onResult]
  );

  useEffect(() => {
    let timerId: number | undefined;

    if (isPolling && isThreeDSTwoAuth(iframeData)) {
      timerId = window.setInterval(() => {
        pollingHandler(iframeData);
      }, 1000);
    }

    return () => {
      // TODO VC-644 - fix types
      // @ts-ignore
      clearInterval(timerId!);
    };
  }, [isPolling]);
}
